"use client";

interface SectionTitleProps {
	title: string;
	className?: string;
	textSize?: string;
}

export const SectionTitle = ({
	title,
	className = "",
	textSize = "text-lg",
}: SectionTitleProps) => {
	return (
		<div
			className={`bg-suzuka2025darkPurple text-white font-bold px-10 py-4 rounded-full w-fit font-zenMaru ${textSize} ${className}`}
		>
			{title}
		</div>
	);
};
